import React, { useEffect, useState } from "react";
import {
    Button,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
} from "reactstrap";
import { useLoader } from "../../_helper/LoaderContext";
import { addPatient, updatePatient } from "../Patient/service/patient-service";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { stateMaster } from "../LabProfile/service/profile-service";

export default function WalkinPatinet({ getData, onPatientCreated }) {

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        age: "",
        gender: "",
        email: "",
        address: "",
        state: "",
    });
    const { setLoading } = useLoader()
    const [errors, setErrors] = useState({});
    const [states, setStates] = useState([]);
    const [statesLoaded, setStatesLoaded] = useState(false);

    const validate = () => {
        const newErrors = {};

        // Name validation — no numbers or special characters
        if (!formData.name.trim()) {
            newErrors.name = "Name is required";
        } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
            newErrors.name = "Only letters and spaces allowed";
        }

        // Age validation
        if (!formData.age.trim()) {
            newErrors.age = "Age is required";
        } else
            if (isNaN(formData.age) || formData.age <= 0) {
                newErrors.age = "Enter valid age";
            }

        // Gender validation
        if (!formData.gender) {
            newErrors.gender = "Gender is required";
        }

        // Mobile validation — only digits, must be 10 digits
        // if (!formData.mobile.trim()) {
        //     newErrors.mobile = "Mobile number is required";
        // }
        // if (!formData.state.trim()) {
        //     newErrors.state = "State is required";
        // }

        // Email validation
        // if (!formData.email.trim()) {
        //     newErrors.email = "Email is required";
        // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        //     newErrors.email = "Enter valid email";
        // }

        // Address validation
        // if (!formData.address.trim()) {
        //     newErrors.address = "Address is required";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validate()) {
            setLoading(true);
            try {
                const form_data = new FormData();
                form_data.append("fname", formData.name);
                form_data.append("age", formData.age);
                form_data.append("gender", formData.gender);
                form_data.append("isWalkIn", true);
                // form_data.append("lname",data.);
                // form_data.append("email", formData.email);
                // form_data.append("contact", formData.mobile);
                // form_data.append("address", formData.address);
                // form_data.append("state", formData.state);
                const res = await addPatient(form_data);
                if (res.data.success == true) {
                    toast.success(res.data.message);
                    setFormData({
                        name: "",
                        mobile: "",
                        age: "",
                        gender: "",
                        email: "",
                        address: "",
                    });
                    setErrors({});
                    onPatientCreated(res.data.data)
                    // getList()
                    if (getData) {
                        getData()
                    }
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
    };

    return (
        <>
            <Form>
                {/* Name */}
                <div className="row">
                    {/* Name */}
                    <div className="col-md-4">
                        <FormGroup className="mb-3">
                            <Label for="name">Name <span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Enter name"
                                value={formData.name}
                                onChange={handleChange}
                                invalid={!!errors.name}
                            />
                            {errors.name && (
                                <div className="invalid-feedback d-block">{errors.name}</div>
                            )}
                        </FormGroup>
                    </div>

                    {/* Age */}
                    <div className="col-md-3">
                        <FormGroup className="mb-3">
                            <Label for="age">Age <span className="text-danger">*</span></Label>
                            <Input
                                type="number"
                                id="age"
                                name="age"
                                placeholder="Enter age"
                                value={formData.age}
                                onChange={handleChange}
                                invalid={!!errors.age}
                            />
                            {errors.age && (
                                <div className="invalid-feedback d-block">{errors.age}</div>
                            )}
                        </FormGroup>
                    </div>

                    {/* Gender */}
                    <div className="col-md-3">
                        <FormGroup className="mb-3">
                            <Label>Gender <span className="text-danger">*</span></Label>
                            <div className="d-flex gap-3 mt-1">
                                <div className="radio radio-primary">
                                    <Input
                                        id="customer-radio-gloabal"
                                        type="radio"
                                        name="gender"
                                        value="male"
                                        checked={formData.gender === "male"}
                                        onChange={handleChange}
                                    />
                                    <Label for="customer-radio-gloabal" className="mb-0 pe-2">
                                        Male
                                    </Label>
                                </div>
                                <div className="radio radio-primary">
                                    <Input
                                        id="customer-radio-female"
                                        type="radio"
                                        name="gender"
                                        value="female"
                                        checked={formData.gender === "female"}
                                        onChange={handleChange}
                                    />
                                    <Label for="customer-radio-female" className="mb-0 pe-2">
                                        Female
                                    </Label>
                                </div>
                            </div>
                            {errors.gender && (
                                <div className="invalid-feedback d-block">{errors.gender}</div>
                            )}
                        </FormGroup>
                    </div>

                    <div className="col-md-2 text-end mt-4">
                        <Button color="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </div>
                    {/* Mobile */}
                    {/* <div className="col-md-6">
                        <FormGroup className="mb-3">
                            <Label for="mobile">Mobile Number</Label>
                            <PhoneInput
                                country={"in"}
                                value={formData.mobile}
                                onChange={(value) => setFormData(prev => ({ ...prev, mobile: value }))}
                                inputProps={{
                                    name: "mobile",
                                    required: true,
                                    className: "form-control"
                                }}
                                enableSearch={true}
                                searchPlaceholder="Search country"
                            />

                            {errors.mobile && (
                                <div className="invalid-feedback d-block">{errors.mobile}</div>
                            )}
                        </FormGroup>
                    </div> */}

                    {/* Email */}
                    {/* <div className="col-md-6">
                        <FormGroup className="mb-3">
                            <Label for="email">Email</Label>
                            <Input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Enter email address"
                                value={formData.email}
                                onChange={handleChange}
                                invalid={!!errors.email}
                            />
                            {errors.email && (
                                <div className="invalid-feedback d-block">{errors.email}</div>
                            )}
                        </FormGroup>
                    </div> */}

                    {/* state */}
                    {/* <div className="col-md-6">
                        <FormGroup className="mb-3">
                            <Label for="state">State </Label>
                            <select
                                className="form-select form-select-lg"
                                value={formData.state}
                                onChange={(e) =>
                                    setFormData(prev => ({ ...prev, state: e.target.value }))
                                }
                            >
                                <option value="">Select State</option>
                                {states.map(s => (
                                    <option key={s._id} value={s.State}>
                                        {s.State}
                                    </option>
                                ))}
                            </select>
                            {errors.state && (
                                <div className="invalid-feedback d-block">{errors.state}</div>
                            )}
                        </FormGroup>
                    </div> */}
                </div>

                {/* Address */}
                {/* <FormGroup className="mb-3">
                    <Label for="address">Address</Label>
                    <Input
                        type="textarea"
                        id="address"
                        name="address"
                        placeholder="Enter address"
                        value={formData.address}
                        onChange={handleChange}
                        invalid={!!errors.address}
                    />
                    {errors.address && (
                        <div className="invalid-feedback d-block">{errors.address}</div>
                    )}
                </FormGroup> */}
            </Form>
        </>
    )
}
